import { el, mount, setAttr } from 'redom';

function getSpinnerImage() {
  let svg = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="177px" height="177px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
<g transform="translate(50 50)">
  <g transform="scale(0.86)">
    <g transform="translate(-50 -50)">
      <g>
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.5s"></animateTransform>
        <path fill-opacity="1" fill="#a0c553" d="M50 50L50 0A50 50 0 0 1 100 50Z"></path>
      </g>
      <g>
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.6666666666666666s"></animateTransform>
        <path fill-opacity="1" fill="#ffcd52" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(90 50 50)"></path>
      </g>
      <g>
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s"></animateTransform>
        <path fill-opacity="1" fill="#01a2b6" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(180 50 50)"></path>
      </g>
      <g>
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="0 50 50;360 50 50" keyTimes="0;1" dur="2s"></animateTransform>
        <path fill-opacity="1" fill="#ea5f66" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(270 50 50)"></path>
      </g>
    </g>
  </g>
</g>
<!-- [ldio] generated by https://loading.io/ --></svg>`;

  return window.btoa(svg);
}

function getStyleEl() {

  const styleCode = `

    .spinner-main {
      background-image: url(data:image/svg+xml;base64,${getSpinnerImage()});
      background-size: contain;
      text-align: center;
      height: 50px;
      width: 50px;
      margin: 0 auto;
      background-repeat: no-repeat;
    }

    .spinner-main.tiny {
      height: 10px;
      width: 10px;
    }

    .spinner-main.small {
      height: 20px;
      width: 20px;
    }

`;

  const style = el('style', styleCode);

  return style;

}

class Spinner extends HTMLElement {

  constructor() {

    super();

    this.attachShadow({
      mode: 'open'
    });

    this.rootEl = el('div.spinner-main');

    mount(this.shadowRoot, getStyleEl());
    mount(this.shadowRoot, this.rootEl);

  }

  connectedCallback() {

    this.trySetSize();

  }

  trySetSize() {

    const size = (this.getAttribute('size') || '').trim();

    if (size === '' || this.rootEl.classList.contains(size) === true) {
      return;
    }

    if (isNaN(+size) === true) {
      this.rootEl.classList.add(size);
    }

    setAttr(this.rootEl, {
      style: {
        width: `${size}px`,
        height: `${size}px`
      }
    });

  }

}

export class InlineSpinner extends HTMLElement {

  constructor() {

    super();

    this.attachShadow({
      mode: 'open'
    });

    this.rootEl = el('span.spinner-main');

    mount(this.shadowRoot, getStyleEl());
    mount(this.shadowRoot, this.rootEl);

  }

}

customElements.define('ht-spinner', Spinner);
customElements.define('ht-inline-spinner', InlineSpinner);

export default Spinner;